import { useCartContext } from "../../Context/CartContext";

import { IoAddOutline } from "react-icons/io5";
import { FaMinus } from "react-icons/fa6";

const CartPageProduct = ({ product }) => {
  const { removeProduct, changeQuantity } = useCartContext();
  const { name, price, image_url, cantidad, description } = product;

  return (
    <div className="flex flex-col w-[100%] h-[250px] bg-slate-50 p-2 gap-2">
      <div className="flex flex-row w-full h-[150px] gap-2">
        <img
          src={`${process.env.REACT_APP_S3_ENDPOINT}/${image_url}`}
          alt={name}
          className="h-full w-[150px] lg:w-[200px] object-cover "
        />

        <div className="flex flex-col gap-2 gap-4 w-full">
          <div className=" font-Roboto text-[18px] font-Roboto font-[400] line-clamp-2 leading-[20px] ">
            {description}
          </div>
          <div className="font-Roboto text-[20px] font-Roboto font-[700]">
            ${price}
          </div>
        </div>
      </div>

      <div className="flex flex-grow items-center w-full gap-4 ">
        <button
          className="max-w-[150px] flex-1 h-[40px] rounded-2xl  border border-solid  border-slate-400 bg-white flex justify-center items-center text-[14px] font-Roboto"
          onClick={() => removeProduct(product)}
        >
          Eliminar
        </button>

        <button className="max-w-[120px] flex-1 h-[40px] rounded-2xl border border-solid border-slate-400 bg-white flex justify-between items-center text-[14px] font-Roboto font-[500] px-2 py-1">
          <FaMinus
            className="text-black text-[20px]"
            onClick={() => {
              if (cantidad > 1) changeQuantity(product, cantidad - 1);
              if (cantidad === 1) {
                removeProduct(product);
              }
            }}
          />

          <div className="text-black text-[20px] ">{cantidad}</div>

          <IoAddOutline
            className="text-black text-[22px] font-bold"
            onClick={() => {
              changeQuantity(product, cantidad + 1);
            }}
          />
        </button>
      </div>
    </div>
  );
};

export default CartPageProduct;
